import React, { PureComponent } from "react";
import Footer from "../presentational/Footer/";
import FooterBox from "../presentational/FooterBox/";
import GoogleMaps from "../presentational/GoogleMaps/";

class FooterContainer extends PureComponent {
  render() {
    const left = (
      <FooterBox title="За контакти">
        <p style={{paddingBottom:'14px'}}>
          Директор за връзки с инвеститорите:
          <br />
          <a href="javascript:" className="has-text-primary">Цветелина Николова</a>
        </p>
        <p>
          Тел.:{" "}
          <a href="javascript:" className="has-text-primary">
            08 9999 5797
          </a>
        </p>
        <p>
          E-mail:{" "}
          <a href="mailto:office@slsimoti.bg" className="has-text-primary">
            office@slsimoti.bg 
          </a>
        </p>
      </FooterBox>
    );
    const middle = (
      <FooterBox title="Адрес">
        <p>Адрес</p>
        <p>София 1592, бул. Христофор Колумб № 43</p>
      </FooterBox>
    );
    const right = <GoogleMaps apiKey="AIzaSyDNm4x-iYi7nyno80Dk8wlMwEH8IgncuZc" />;

    return <Footer left={left} middle={middle} right={right} />;
  }
}

export default FooterContainer;



// WEBPACK FOOTER //
// ./src/containers/Footer.js